import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i1$1 from 'angular-i18next';
import { I18NEXT_SERVICE, I18NextModule } from 'angular-i18next';
import { BehaviorSubject, Subject, lastValueFrom } from 'rxjs';
import * as i1 from '@angular/common/http';

class DokaI18NextService {
    constructor(i18nextService, http) {
        this.i18nextService = i18nextService;
        this.http = http;
        this.availableTranslations = [];
        this.selectedLanguage = 'en';
        this.isChangingLanguage = false;
        this.isLoadingAvailableLanguages = false;
        this.events = {
            initialized: new BehaviorSubject(undefined),
            langChanged: new Subject(),
        };
        this.langChanged = new Subject();
        this._translationsUrl = null;
        this._clientId = null;
        this.i18nextService.events.languageChanged.subscribe(e => {
            console.log(e);
        });
    }
    async init(translationsUrl, clientId) {
        this._translationsUrl = translationsUrl;
        this._clientId = clientId;
        this.events.initialized = this.i18nextService.events.initialized;
        this.events.langChanged = this.i18nextService.events.languageChanged;
        this.i18nextService.events.initialized.subscribe(e => {
            console.log(e);
            if (e?.lng) {
                this.selectedLanguage = e.lng;
            }
        });
        this.i18nextService.events.languageChanged.subscribe(e => {
            if (e) {
                console.log(e);
                this.selectedLanguage = e;
            }
        });
        await this.getAvailableLanguages();
    }
    async changeLanguage(lng) {
        this.isChangingLanguage = true;
        try {
            await this.i18nextService.reloadResources(lng);
            await this.i18nextService.changeLanguage(lng);
            this.selectedLanguage = lng;
        }
        catch (error) {
            console.warn(error);
        }
        finally {
            this.isChangingLanguage = false;
        }
    }
    async getAvailableLanguages() {
        const url = `${this._translationsUrl}/api/translations/${this._clientId}`;
        let res;
        try {
            res = await lastValueFrom(this.http.get(url));
        }
        catch (error) {
            console.warn("could not get availableTranslations", error);
        }
        if (res) {
            this.availableTranslations = res;
        }
        else {
            this.availableTranslations = [];
        }
    }
    instant(key) {
        if (key) {
            const fallBack = "en";
            const translation = this.i18nextService.getResource(this.i18nextService.language, 'translation', key);
            const fallbackTranslation = this.i18nextService.getResource(fallBack, 'translation', key);
            if (translation && Object.keys(translation).length > 0) {
                return translation;
            }
            else if (fallbackTranslation) {
                return fallbackTranslation;
            }
            else {
                return key;
            }
        }
        else {
            return null;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: DokaI18NextService, deps: [{ token: I18NEXT_SERVICE }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: DokaI18NextService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: DokaI18NextService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [I18NEXT_SERVICE]
                }] }, { type: i1.HttpClient }] });

class DokaI18NextModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: DokaI18NextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.8", ngImport: i0, type: DokaI18NextModule, imports: [i1$1.I18NextModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: DokaI18NextModule, imports: [I18NextModule.forRoot()] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: DokaI18NextModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        I18NextModule.forRoot()
                    ],
                    exports: [],
                }]
        }] });

/*
 * Public API Surface of translation
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DokaI18NextModule, DokaI18NextService };
